// plugins/permissions.js
import can from '~/helpers/can';

export default {
  install(app) {
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$can = can;
  },
};
